import { tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div`
  max-width: 970px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px 10px 50px 10px;
  text-align: center;
`;

export const Logo = styled.img`
  vertical-align: middle;
  margin-bottom: 30px;
`;

export const TitleHeader = styled.section`
  text-align: center;
  margin: 30px 10px;
`;

export const WaysContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 15px;

  @media (${tabletMax}) {
    flex-direction: column;
  }
`;

export const InfoBox = styled.div`
  padding: 30px;
  background: ${({ theme }) => theme.backgroundLightest};
  text-align: left;
  flex: 1;

  @media (${tabletMax}) {
    padding: 30px 15px;
    margin-bottom: 10px;
  }
`;
